module.exports = __webpack_public_path__ + "img/2_224.7af1ef7d.png";